import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled, { ThemeProvider } from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import ExampleComponent from '../ExampleComponent'
import { GlobalVariables } from 'Globals/GlobalVariables'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
}: MicroFrontendProps) => {
  const theme = {
    backgroundColor: colorMode === 'dark' ? '#ffe462' : '#202346',
    fontColor: colorMode === 'dark' ? '#202346' : '#ffffff',
    invertedBackgroundColor: colorMode === 'dark' ? '#6f7187' : '#ffe462',
    invertedFontColor: colorMode === 'dark' ? '#ffe462' : '#202346',
    borderColor: colorMode === 'dark' ? '#20234622' : '#ffffff22',
    tenant: tenant,
  }

  return (
    <AppContainer $colorMode={colorMode}>
      <ThemeProvider theme={theme}>
        <ExampleComponent />
      </ThemeProvider>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  margin-bottom: 4rem;
  margin-top: 2rem;
`
export default MainComponent
